import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import {
  DocumentIcon,
  TruckIcon,
  ShipIcon,
  BellIcon,
  ServerIcon,
  ShieldIcon,
  PlaneIcon,
  ISFIcon,
  CheckIcon
} from '../../assets/icons';
import { landingContent } from '../../config/content.config';
import Badge from "../Badge/Badge";
import './Features.css';

const iconMap = {
  TruckIcon: <TruckIcon className="feature-icon" />,
  ShipIcon: <ShipIcon className="feature-icon" />,
  PlaneIcon: <PlaneIcon className="feature-icon" />,
  DocumentIcon: <DocumentIcon className="feature-icon" />,
  BellIcon: <BellIcon className="feature-icon" />,
  ServerIcon: <ServerIcon className="feature-icon" />,
  ShieldIcon: <ShieldIcon className="feature-icon" />,
  ISFIcon: <ISFIcon className="feature-icon" />
};

const Features = () => {
  const { features } = landingContent;
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();

  return (
    <section id="features" className="features">
      <div className="features-inner">
        <div
          ref={headerRef}
          className={`features-header scroll-animate ${headerVisible ? "is-visible" : ""}`}
        >          
          <Badge>{features.header.label}</Badge>
          <h2 className="section-title">{features.header.title}</h2>
          <p className="features-description">{features.header.description}</p>
        </div>

        <div ref={gridRef} className="features-grid">
          {features.main.map((feature, index) => (
            <div
              key={index}
              className={`feature-card-wrapper scroll-animate-container ${gridVisible ? "is-visible" : ""}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="card feature-card">
                <div className="feature-icon-wrapper">
                  {iconMap[feature.icon]}
                </div>
                <h3 className="card-title">{feature.title}</h3>
                <p className="card-description">{feature.description}</p>
                <div className="feature-list">
                  {feature.items.map((item, idx) => (
                    <div key={idx} className="feature-list-item">
                      <CheckIcon className="detailed-feature-list-icon" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Detailed Features */}
        <div className="detailed-features">
          {features.detailed.map((feature, index) => (
            <DetailedFeature key={index} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

// Separate component for detailed features to use hooks properly
const DetailedFeature = ({ feature, index }) => {
  const { ref, isVisible } = useScrollAnimation();
  
  return (
    <div
      ref={ref}
      className={`detailed-feature-wrapper scroll-animate-container ${isVisible ? "is-visible" : ""}`}
    >
      <div className="detailed-feature">
        <div className="detailed-feature-content">
          <span className="detailed-feature-label">{feature.label}</span>
          <h3 className="detailed-feature-title">{feature.title}</h3>
          <div className="detailed-feature-visual mobile-only">
            <div className="detailed-feature-accent"></div>
            <div className="detailed-feature-image">
              <img
                src={feature.image}
                alt={feature.title}
                className="detailed-feature-image"
              />
            </div>
          </div>
          <p className="detailed-feature-description">{feature.description}</p>
          <ul className="detailed-feature-list">
            {feature.items.map((item, idx) => (
              <li key={idx}>
                <CheckIcon className="detailed-feature-list-icon" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="detailed-feature-visual desktop-only">
          <div className="detailed-feature-accent"></div>
          <div className="detailed-feature-image">
            <img
              src={feature.image}
              alt={feature.title}
              className="detailed-feature-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
